import type { CurrentUserInfo } from '@/shared/types/CurrentUserInfo'
import type { CustomerSwitcherPayload } from '@/shared/types/CustomerSwitcherPayload'

// LogRocket's IUserTraits only accepts string | number | boolean — no null.
// We omit optional fields rather than passing null so LogRocket treats them
// as "not set" rather than "set to null" (which would be serialised as a string).
export type LogRocketIdentifyTraits = Record<string, string | number | boolean>

export const buildLogRocketIdentifyPayload = (
  user: CurrentUserInfo,
  customerSwitcher: CustomerSwitcherPayload | null | undefined,
): LogRocketIdentifyTraits => {
  const traits: LogRocketIdentifyTraits = {
    name: user.name,
    email: user.email,
  }
  if (customerSwitcher?.currentCustomerId != null) {
    traits.tenantId = customerSwitcher.currentCustomerId
  }
  if (customerSwitcher?.currentCustomerName != null) {
    traits.tenantName = customerSwitcher.currentCustomerName
  }
  return traits
}
